import { call, put, takeLatest, select } from 'redux-saga/effects';
import type { PayloadAction } from '@reduxjs/toolkit';
import apiService from '../../api/service/apiService';
import ENDPOINTS from '../../api/endPoints';
import {
  fetchCampaignsRequest,
  fetchCampaignsSuccess,
  fetchCampaignsFailure,
  deleteCampaignRequest,
  deleteCampaignSuccess,
  deleteCampaignFailure,
} from '../slices/campaignsSlice';
import type { Campaign } from '../slices/campaignsSlice';
import type { RootState } from '../store';

function* fetchCampaignsSaga(): Generator<any, void, any> {
  try {
    const restaurantId: string = yield select((state: RootState) => state.clover.restaurantId);

    const response = yield call(apiService.get, {
      endpoint: ENDPOINTS.getAllCampaigns,
      headers: {
        'restaurant-id': restaurantId,
      },
    });

    const campaignsData: Campaign[] = response.data?.data?.items || [];

    yield put(fetchCampaignsSuccess(campaignsData));
  } catch (error: any) {
    const errorMessage = error?.message || 'Failed to fetch campaigns';
    yield put(fetchCampaignsFailure(errorMessage));
    console.error('Campaigns Saga Error:', error);
  }
}

function* deleteCampaignSaga(action: PayloadAction<string>): Generator<any, void, any> {
  const campaignId = action.payload;

  try {
    const restaurantId: string = yield select((state: RootState) => state.clover.restaurantId);

    yield call(apiService.delete, {
      endpoint: ENDPOINTS.deleteCampaign(campaignId),
      headers: {
        'restaurant-id': restaurantId,
      },
    });

    yield put(deleteCampaignSuccess(campaignId));

  } catch (error: any) {
    const errorMessage = error?.message || 'Failed to delete campaign';
    yield put(deleteCampaignFailure(errorMessage));
    console.error('Delete Campaign Saga Error:', error);
  }
}

export default function* campaignsSagaWatcher() {
  yield takeLatest(fetchCampaignsRequest.type, fetchCampaignsSaga);
  yield takeLatest(deleteCampaignRequest.type, deleteCampaignSaga);
}
